// Canonical organization that owns the Promoter OS workforce and onboarding flow.
export const PRIMARY_OPERATIONS_ORG_ID = 'b53cbd9d-b000-4d58-a703-419ab2cf067b';
